module.exports = __webpack_public_path__ + "static/media/live_chat.ec0f06a8.svg";